import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

function SelectFilter({ handleFilterChange, options, placeholder, isClearable, value, width }) {
  return (
    <Select
      styles={{
        menu:      (provided) => ({ ...provided, zIndex: 9999  }),
        container: (base) => ({
          ...base,
          width,
        }),
      }}
      value={value ? { label: value, value } : ''}
      onChange={handleFilterChange}
      options={options}
      closeMenuOnSelect={false}
      blurInputOnSelect={false}
      placeholder={placeholder}
      isClearable={isClearable}
    />
  );
}

SelectFilter.propTypes = {
  handleFilterChange: PropTypes.func.isRequired,
  placeholder:        PropTypes.string,
  options:            PropTypes.arrayOf(PropTypes.any),
  isClearable:        PropTypes.bool,
  value:              PropTypes.string,
  width:              PropTypes.string,
};

SelectFilter.defaultProps = {
  placeholder: '',
  options:     [],
  isClearable: true,
  value:       null,
  width:       '100px',
};

export default SelectFilter;
